// Representative recoveries. Anonymized. Outcome-focused. No marketing language.
export const CASE_OUTCOMES = [
  {
    id: "case-001",
    claim_type: "Hurricane",
    location: "Naples, FL",
    challenge: "Initial denial citing pre-existing roof condition on a coastal single-family home.",
    outcome: "$1,420,000 recovered after re-documentation and engineering report.",
    year: "2024",
  },
  {
    id: "case-002",
    claim_type: "Water Damage",
    location: "Tampa, FL",
    challenge: "Carrier classified loss as long-term seepage, excluding it from coverage.",
    outcome: "$186,300 settlement after timeline reconstruction and supply-line failure evidence.",
    year: "2024",
  },
  {
    id: "case-003",
    claim_type: "Commercial Property",
    location: "Orlando, FL",
    challenge: "Underpaid claim on a 28,000 sq. ft. retail center after a tropical storm.",
    outcome: "$612,000 supplemental recovery beyond original carrier offer.",
    year: "2023",
  },
  {
    id: "case-004",
    claim_type: "Condominium Association",
    location: "Sarasota, FL",
    challenge: "Disputed scope between association and unit-owner responsibility after Hurricane Ian.",
    outcome: "$3,240,000 association recovery; unit owners separately represented.",
    year: "2024",
  },
  {
    id: "case-005",
    claim_type: "Fire & Smoke",
    location: "Kissimmee, FL",
    challenge: "Closed claim with under-documented contents and smoke contamination scope.",
    outcome: "$248,700 reopened recovery including ALE entitlements.",
    year: "2024",
  },
  {
    id: "case-006",
    claim_type: "Roof Damage",
    location: "Tampa, FL",
    challenge: "Carrier authorized partial roof replacement; matching shingles unavailable.",
    outcome: "Full roof replacement plus ordinance-or-law coverage applied.",
    year: "2024",
  },
];

export const NUMBERS = [
  { value: 47, suffix: "M+", label: "Recovered for Policyholders", prefix: "$" },
  { value: 1200, suffix: "+", label: "Claims Represented" },
  { value: 12, suffix: "", label: "Years of Florida Practice" },
  { value: 5, suffix: "", label: "Launch Markets — Statewide" },
];
